import { useState } from 'react'
import { Box } from 'theme-ui'

import BaseButton from 'src/components/common/buttons/BaseButton'
import Modal from 'src/components/common/modal/Modal'
import Type from 'src/components/gel/Type'

const NewsletterModal = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <BaseButton
        variant="buttons.tertiary"
        text="Join our newsletter"
        onClick={() => setIsOpen(true)}
      />
      <Modal
        isOpen={isOpen}
        closeModal={() => setIsOpen(false)}
        title={
          <Type variant="LabelsSerif">
            <Box as="b">The Ad</Box>vantage
          </Type>
        }
      >
        <iframe
          title="The Advantage form"
          src="https://mailer.bbcstudios.com/p/1JJD-1PRG/the-advantage"
          style={{
            border: '1px solid white',
            width: '100%',
            height: '560px'
          }}
        />
      </Modal>
    </>
  )
}

export default NewsletterModal
